export class Lazy<T> {
  private generator: () => T;
  private isLoaded: boolean;
  private value: T;
  constructor(generator: () => T) {
    this.generator = generator;
  }

  get(): T {
    if (!this.isLoaded) {
      this.value = this.generator();
      this.isLoaded = true;
    }
    return this.value;
  }
}

export function lazy<T>(generator: () => T): Lazy<T> {
  return new Lazy<T>(generator);
}
